export const Account_Opt_Link=(props)=>{
    return (<div className="col-lg-12 order-lg-first col-md-12 order-md-last mb-md-60px mb-lm-60px">
        
               
    <div className="sidebar-widget-category center">
        <ul class="nav nav-tabs justify-content-center scrollmenu">
            {/* <li><a href="./my_profile" className="selected">My Profile</a></li> */}
            <li class="nav-item"><a href="../dashboard" className="btn-sm btn-lg btn-primary btn-hover-dark mt-5 nav-link">Dashboard</a></li>
            <li class="nav-item"><a href="../my_profile" className="btn-sm btn-lg btn-primary btn-hover-dark mt-5 nav-link">My Profile</a></li>
            
            <li class="nav-item"><a href="../purchase_history" className="btn-sm btn-lg btn-primary btn-hover-dark mt-5 nav-link">Purchase History</a></li>
            <li class="nav-item"><a href="../deduction_summary" className="btn-sm btn-lg btn-primary btn-hover-dark mt-5 nav-link">Deduction Log</a></li>
            <li class="nav-item"><a href="../view_all_request" className="btn-sm btn-lg btn-danger btn-hover-dark mt-5 nav-link">Request List</a></li>
            {/* <li><a href="#" className="">Customer Care</a></li> */}
        </ul>    
        
    </div>
</div>);
}

export default Account_Opt_Link;